import { render, staticRenderFns } from "./UsersCreateModal.vue?vue&type=template&id=2d9c844a&"
import script from "./UsersCreateModal.vue?vue&type=script&lang=js&"
export * from "./UsersCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports